import { useState } from 'react';
import { CButton, CCard, CCardBody, CCardImage, CCardText, CCardTitle, CPlaceholder } from '@coreui/bootstrap-react/src/index';
import ReactImg from "../../../../content/1.0/assets/images/react.jpg";
import * as React from 'react';
export default {
  useState,
  CButton,
  CCard,
  CCardBody,
  CCardImage,
  CCardText,
  CCardTitle,
  CPlaceholder,
  ReactImg,
  React
};